import { Message } from '@ncss/message';
import { NL4 } from '@ncss/models';
import { ByteList } from 'byte-list';

export class NL4BLEDeviceMessage extends Message {
    nl4?: NL4;


    serialize(): ByteList {
        const bytes = super.serialize();
        this.nl4 = this.nl4 || new NL4();
        this.nl4.serialize(bytes);
        return bytes;
    }

    deserialize(bytes: ByteList): void {
        super.deserialize(bytes);
        this.nl4 = new NL4();
        this.nl4.deserialize(bytes);
    }
}
